// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-components-mdx-page-js": () => import("./../../../src/components/mdxPage.js" /* webpackChunkName: "component---src-components-mdx-page-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

